export default function PrivacyPolicyPage() {
  return (
    <div className="card">
      <h2>Privacy Policy – SiftMyMail</h2>
      <p>
        <strong>Effective date:</strong> December 15, 2025
      </p>
      <p>
        SiftMyMail is developed and maintained by Christy and Ryan, LLC, a Texas-based company. We are committed to
        protecting your privacy and minimizing data access.
      </p>
      <ol>
        <li>
          <strong>Information We Access</strong>
          <p>
            When you sign in with Google, SiftMyMail requests limited access to your Gmail account only to provide email
            risk analysis. This may include email headers, sender information, subject lines, and message content for
            emails you choose to view.
          </p>
        </li>
        <li>
          <strong>How Your Data Is Processed</strong>
          <p>
            All analysis is performed locally in your web browser. Email content is not sent to our servers, stored, or
            shared with third parties.
          </p>
        </li>
        <li>
          <strong>What We Do Not Do</strong>
          <p>We do not sell, share, or monetize user data. We do not use analytics, tracking, or advertising technologies.</p>
        </li>
        <li>
          <strong>Data Storage</strong>
          <p>Authentication tokens may be stored locally in your browser to maintain your session. No Gmail message data is stored on our servers.</p>
        </li>
        <li>
          <strong>Data Deletion &amp; Revocation</strong>
          <p>Users may revoke access at any time through their Google Account security settings. Signing out and clearing data removes locally stored information.</p>
        </li>
        <li>
          <strong>Children’s Privacy</strong>
          <p>SiftMyMail does not knowingly collect personal information from children under 13.</p>
        </li>
        <li>
          <strong>Changes to This Policy</strong>
          <p>We may update this Privacy Policy as the app evolves. Updates will be posted on this page with a revised effective date.</p>
        </li>
        <li>
          <strong>Contact</strong>
          <p>Email: christy--ryan-app-support@googlegroups.com</p>
          <p>Christy and Ryan, LLC — Texas, United States</p>
        </li>
      </ol>
    </div>
  );
}
